import { saveUtilityCache } from '../../../utils/utilityAppStorage';
import { useEffect, useState } from 'react';
import { v4 as uuid } from 'uuid';

const STORAGE_KEY = 'libroComprasData';

export function useCompras() {
  const [compras, setCompras] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored ? JSON.parse(stored) : [];
    } catch (e) {
      console.error('Error leyendo localStorage', e);
      return [];
    }
  });

  useEffect(() => {
    try {
      saveUtilityCache(STORAGE_KEY, compras);
    } catch (e) {
      console.error('Error guardando localStorage', e);
    }
  }, [compras]);

  const agregarCompra = (data) => {
    setCompras(prev => [
      ...prev,
      {
        id: uuid(),
        ...data,
        estado: 'ACTIVA',
        createdAt: new Date().toISOString(),
        updatedAt: null,
        motivoAnulacion: null
      }
    ]);
  };

  const editarCompra = (id, data) => {
    setCompras(prev =>
      prev.map(c =>
        c.id === id
          ? { ...c, ...data, updatedAt: new Date().toISOString() }
          : c
      )
    );
  };

  const anularCompra = (id, motivo) => {
    setCompras(prev =>
      prev.map(c =>
        c.id === id
          ? {
              ...c,
              estado: 'ANULADA',
              motivoAnulacion: motivo,
              updatedAt: new Date().toISOString()
            }
          : c
      )
    );
  };

  return { compras, agregarCompra, editarCompra, anularCompra };
}
